import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import Button from '4all-ui/components/Button';
import { customModalStyles } from '../../helpers/constants';
import * as styles from './style';
import GenericList from '../GenericList';
import { isAllUnchecked } from '../../helpers/products';
import ProductListItem from '../ProductListItem';
import { GRAY_LIGHTER } from '../../styles/variables';
import { getParentSelector } from '../../helpers/modal';

class SelectProductsModal extends React.Component {
  state = {
    categories: [],
  };

  componentDidUpdate(prevProps) {
    const { categories } = this.props;
    if (this.shouldUpdateCategories(prevProps)) {
      this.setState({
        categories,
      });
    }
  }

  toggleCategory = async categoryId => {
    await this.setCategories();
    this.setState(state => ({
      categories: state.categories.map(cat =>
        cat.id === categoryId
          ? {
              ...cat,
              products: cat.products.map(prod => ({
                ...prod,
                checked: prod.disabled ? false : isAllUnchecked(cat.products),
              })),
            }
          : cat
      ),
    }));
  };

  toggleProduct = async (categoryId, productId) => {
    await this.setCategories();
    this.setState(state => ({
      categories: state.categories.map(cat =>
        cat.id === categoryId
          ? {
              ...cat,
              products: cat.products.map(prod =>
                !prod.disabled && productId === prod.id
                  ? {
                      ...prod,
                      checked: !prod.checked,
                    }
                  : prod
              ),
            }
          : cat
      ),
    }));
  };

  setCategories = async () => {
    const { categories } = this.props;
    if (!this.state.categories.length) {
      this.setState({
        categories,
      });
    }
  };

  closeModal = () => {
    const { closeModal } = this.props;
    closeModal();
    this.clearCategories();
  };

  saveSelection = () => {
    const { onSubmit, closeModal } = this.props;
    const { categories } = this.state;

    if (categories.some(cat => cat.products.some(prod => prod.checked))) {
      onSubmit(categories);
    } else {
      closeModal(true);
    }

    this.clearCategories();
  };

  clearCategories = () => {
    this.setState({ categories: [] });
  };

  shouldUpdateCategories(prevProps) {
    const { categories } = this.props;
    const isStateEmptyAndHasProps = !this.state.categories.length && this.props.categories.length;
    const hasCategoriesChanged =
      JSON.stringify(prevProps.categories) !== JSON.stringify(categories);
    return hasCategoriesChanged || isStateEmptyAndHasProps;
  }

  render() {
    const { isLoading, isOpen } = this.props;
    const { categories } = this.state;

    const filteredCategories = categories.filter(cat => cat.products.length > 0);
    const serializedCategories = filteredCategories.map(cat => ({
      ...cat,
      options: cat.products,
    }));

    return (
      <Modal
        ariaHideApp={false}
        isOpen={isOpen}
        style={{
          ...customModalStyles,
          content: {
            ...customModalStyles.content,
            width: '90%',
            maxWidth: '740px',
            height: 'auto',
          },
        }}
        onRequestClose={this.closeModal}
        parentSelector={getParentSelector}
      >
        <styles.Container>
          <styles.Content>
            <GenericList
              id="select-products"
              title="Selecione os Produtos"
              desc="Selecione mais de um produto se você quiser que esse passo seja condicional."
              searchPlaceholder="Buscar por produto ou categoria"
              search={false}
              headerStyles={{
                marginBottom: '35px',
              }}
              customListStyles={{
                height: '309px',
              }}
              options={serializedCategories}
              isLoading={isLoading}
              CustomItem={ProductListItem}
              toggleParentItem={this.toggleCategory}
              toggleItem={this.toggleProduct}
            />
          </styles.Content>
          <styles.Footer>
            <Button
              secondary
              width="100px"
              customStyles={{ borderColor: GRAY_LIGHTER }}
              onClick={this.closeModal}
              id="select-products-modal-close-btn"
            >
              Fechar
            </Button>
            <Button
              onClick={this.saveSelection}
              id="select-products-modal-add-btn"
              disabled={!categories.some(cat => cat.products.some(prod => prod.checked))}
            >
              Adicionar Produto
            </Button>
          </styles.Footer>
        </styles.Container>
      </Modal>
    );
  }
}

SelectProductsModal.propTypes = {
  categories: PropTypes.array.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};

SelectProductsModal.defaultProps = {
  isOpen: false,
};

export default SelectProductsModal;



// WEBPACK FOOTER //
// ./src/components/SelectProductsModal/index.js